const platform = require('./platform');

module.exports = (() => {
  if (platform.isProduction) return 'production';
  if (platform.isStaging) return 'staging';
  if (platform.isDevelopment) return 'development';
  return 'test';
})();
